import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Main = styled.main`
  position: absolute;
  left: 80px; /* Navigation width */
  width: calc(100% - 80px);
`;
